import fetch from '../fetch';
import { errorMessages } from '../../constants';
import { FULFILLMENTS_DOWNSELL } from '../../constants/endpoints';

export const DOWNSELL_SUBSCRIPTION = 'DOWNSELL_SUBSCRIPTION';
export const SUBSCRIPTION_DOWNSOLD = 'SUBSCRIPTION_DOWNSOLD';
export const DOWNSELL_FAILED = 'DOWNSELL_FAILED';
export default () => async (dispatch, getState) => {
  const state = getState();

  const subscriptionId = state.subscriptions.current?.id;
  const offerId = state.selection?.offerId;

  dispatch({ type: DOWNSELL_SUBSCRIPTION });

  if (!subscriptionId || !offerId) {
    const errorMessage = {
      heading: errorMessages.someDataMissing,
      messages: [errorMessages.technicalIssues],
    };

    const action = {
      type: DOWNSELL_FAILED,
      error: true,
      payload: new Error(JSON.stringify(errorMessage)),
    };

    dispatch(action);
    return action;
  }

  try {
    const requestBody = {
      method: 'PUT',
      body: {
        subscriptionId,
        offerId,
      },
    };

    const result = await dispatch(fetch(FULFILLMENTS_DOWNSELL, requestBody));

    // Extract subscriptionId from the response array
    const downsoldSubscriptionId = result?.data?.[0]?.subscriptionId;
    const succeeded = !!downsoldSubscriptionId;

    const action = {
      type: SUBSCRIPTION_DOWNSOLD,
      payload: {
        success: succeeded,
        subscriptionId: downsoldSubscriptionId,
      },
    };

    dispatch(action);
    return action;
  } catch (error) {
    const errorMessage = {
      heading: errorMessages.someDataMissing,
      messages: [errorMessages.technicalIssues],
    };

    const action = {
      type: DOWNSELL_FAILED,
      error: true,
      payload: new Error(JSON.stringify(errorMessage)),
    };

    dispatch(action);
    return action;
  }
};
